module.exports = __webpack_public_path__ + "4846dda15c68d95ecbea6436b29cb8e0.svg";